interface EnvConfig {
  password: string;
  scoreboardDataLink: string;
  classInfoLink: string;
  enrollmentJotform: string;
  rulesProtocolLink: string;
  graduatesLink: string;
  recruitHwJotform: string;
  salesHwJotform: string;
  eventsHwJotform: string;
  bonusHwJotform: string;
  bookSummaryHwJotform: string;
  hwSlides: string;
}

const requiredEnvVars = [
  'REACT_APP_PASSWORD',
  'REACT_APP_SCOREBOARD_DATA_LINK',
  'REACT_APP_CLASS_INFO_LINK',
  'REACT_APP_ENROLLMENT_JOTFORM',
  'REACT_APP_RULES_PROTOCOL_LINK',
  'REACT_APP_GRADUATES_LINK',
  'REACT_APP_RECRUIT_HW_JOTFORM',
  'REACT_APP_SALES_HW_JOTFORM',
  'REACT_APP_EVENTS_HW_JOTFORM',
  'REACT_APP_BONUS_HW_JOTFORM',
  'REACT_APP_BOOK_SUMMARY_HW_JOTFORM',
  'REACT_APP_HW_SLIDES',
];

const validateEnv = (): void => {
  const missing = requiredEnvVars.filter(
    (key) => !process.env[key]
  );

  if (missing.length > 0) {
    throw new Error(
      `Missing required environment variables: ${missing.join(', ')}`
    );
  }
};

validateEnv();

export const env: EnvConfig = {
  password: process.env.REACT_APP_PASSWORD!,
  scoreboardDataLink: process.env.REACT_APP_SCOREBOARD_DATA_LINK!,
  classInfoLink: process.env.REACT_APP_CLASS_INFO_LINK!,
  enrollmentJotform: process.env.REACT_APP_ENROLLMENT_JOTFORM!,
  rulesProtocolLink: process.env.REACT_APP_RULES_PROTOCOL_LINK!,
  graduatesLink: process.env.REACT_APP_GRADUATES_LINK!,
  recruitHwJotform: process.env.REACT_APP_RECRUIT_HW_JOTFORM!,
  salesHwJotform: process.env.REACT_APP_SALES_HW_JOTFORM!,
  eventsHwJotform: process.env.REACT_APP_EVENTS_HW_JOTFORM!,
  bonusHwJotform: process.env.REACT_APP_BONUS_HW_JOTFORM!,
  bookSummaryHwJotform: process.env.REACT_APP_BOOK_SUMMARY_HW_JOTFORM!,
  hwSlides: process.env.REACT_APP_HW_SLIDES!,
};
